export default __webpack_public_path__ + "static/SR France - ISO 9001 - Certificate-579c4d90405b9fcd41b115fd35c2e10a.pdf";